import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { Cookie } from 'ng2-cookies/ng2-cookies';

@Component({
  selector: 'app-troubleshooting',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './troubleshoot.component.html',
  styleUrls: ['./troubleshoot.component.scss'],
})
export class TroubleshootingComponent {
  constructor(private router: Router) {}

  isRunning = false;
  isDone = false;

  steps = {
    storage: false,
    cookies: false,
    caches: false,
    redirect: false,
  };

  async runClearAndRedirect(): Promise<void> {
    this.isRunning = true;

    // Step 1: Clear storage
    try {
      localStorage.clear();
      sessionStorage.clear();
    } catch {}
    this.steps.storage = true;
    await this.delay(400);

    // Step 2: Clear cookies
    try {
      document.cookie.split(';').forEach(cookie => {
        const name = cookie.split('=')[0].trim();
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      });
    } catch {}
    this.steps.cookies = true;
    await this.delay(400);

    // Step 3: Clear caches & service workers
    try {
      if ('caches' in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map(key => caches.delete(key)));
      }
      if ('serviceWorker' in navigator) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map(r => r.unregister()));
      }
    } catch {}
    this.steps.caches = true;
    await this.delay(400);

    // Step 4: Redirect
    this.steps.redirect = true;
    this.isRunning = false;
    this.isDone = true;
    await this.delay(800);

    // Clear auth
    document.cookie = `AuthToken=bar; expires=0; domain=.singsnap.com`;
    Cookie.deleteAll();
    localStorage.removeItem('token');

    await this.router.navigate(['/login']);
    window.location.reload();
  }

  private delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  gotoSupportPM() {
    this.router.navigateByUrl('/private-message/inbox', { skipLocationChange: false }).then(() =>
      this.router.navigate(['/d/private-message/', 'inbox', 247]));
  }
}
